module.exports = __webpack_public_path__ + "img/makuuhuone_thumbnail_x2.b2024a71.jpg";